import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  Panel,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Button,
  Row,
  Col
} from 'react-bootstrap';
import {
  PlansPermissionsSelector,
  PlansDiscountForm,
  ConfirmationPrompt,
  LoadingSpinner
} from 'components';
import { requestCreatePlan, push } from 'actions';
import _ from 'lodash';

class PlanForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      description: '',
      type: null,
      currency: 'usd',
      month_amount: 0,
      year_amount: 0,
      permissions: [],
      discounts: [],
      removing_discount_idx: null,
      updating: false
    }

    this.plan_type_options = [
      { value: 'map_city', label: 'Map - City' },
      { value: 'map_state', label: 'Map - State' },
      { value: 'map_national', label: 'Map - National' },
      { value: 'crm', label: 'CRM' },
      { value: 'canvassing', label: 'Canvassing' },
      { value: 'data', label: 'Data'}
    ];

    this.plan_interval_options = [
      { value: 'month', label: 'Month' },
      { value: 'year', label: 'Year' }
    ];

    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handlePermissionsChange = this.handlePermissionsChange.bind(this);
    this.handleAddDiscount = this.handleAddDiscount.bind(this);
    this.handleEditDiscount = this.handleEditDiscount.bind(this);
    this.confirmRemoveDiscount = this.confirmRemoveDiscount.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleAmountChange(type, value) {
    if(/^[0-9]*$/.test(value)) {
      this.setState({ [`${type}_amount`]: value });
    }
  }
  handlePermissionsChange(e) {
    let updated_permissions = [ ...this.state.permissions ];
    e.features.forEach(f => {
      if(updated_permissions.find(p => p == f)) {
        updated_permissions = updated_permissions.filter(p => p != f);
      }
      else {
        updated_permissions.push(f);
      }
    });
    this.setState({ permissions: updated_permissions });
  }
  handleAddDiscount(discount_props) {
    const new_discount_props = _.omit({
      ...discount_props,
      max: discount_props.infinite_max ? null : discount_props.max
    }, [ 'infinite_max' ]);
    this.setState({ discounts: [ ...this.state.discounts, new_discount_props ] });
  }
  handleEditDiscount(idx, discount_props) {
    const updated_discount_props = _.omit({
      ...discount_props,
      max: discount_props.infinite_max ? null : discount_props.max
    }, [ 'infinite_max' ]);
    this.setState({ discounts: this.state.discounts.map((d, i) => i == idx ? updated_discount_props : d) });
  }
  confirmRemoveDiscount() {
    this.setState({
      discounts: this.state.discounts.filter((d, i) => i != this.state.removing_discount_idx),
      removing_discount_idx: null
    });
  }
  handleSave() {
    if(this.state.updating) {
      const { name, description } = this.state;
      this.props.handleSave({ ...this.props.plan, name, description });
    }
    else {
      const permission_paths = this.state.permissions.map(p => this.props.features.features_list.find(f => f._id == p || f.path == p).path);
      const payload = _.omit(
        { ...this.state, permissions: permission_paths },
        [
          'removing_discount_idx',
          'show_cancel_new_plan_prompt',
          'month_amount',
          'year_amount'
        ]
      );

      // Must create a monthly and yearly plan
      this.props.handleSave({ ...payload, interval: 'month', amount: this.state.month_amount });
      this.props.handleSave({ ...payload, interval: 'year', amount: this.state.year_amount })
    }
  }
  componentWillMount() {
    if(this.props.plan) {
      this.setState({ ...this.props.plan, updating: true });
    }
  }
  render() {
    const { requesting_create_plan, requesting_update_plan } = this.props.plans;
    return (
      <div className='plan-form-container'>
        <FormGroup>
          <ControlLabel>Plan Name</ControlLabel>
          <FormControl
            onChange={e => this.setState({ name: e.target.value })}
            value={this.state.name}
            placeholder='Plan Name'
          />
          <HelpBlock>Plan names must be unique</HelpBlock>
        </FormGroup>
        <FormGroup>
          <ControlLabel>Plan Description</ControlLabel>
          <FormControl
            onChange={e => this.setState({ description: e.target.value })}
            value={this.state.description}
            componentClass='textarea'
            placeholder='Plan Description'
          />
        </FormGroup>
        {!this.state.updating ? (
          <div>
            <Row>
              <Col md={6} xs={6}>
                <FormGroup>
                  <ControlLabel>Monthly Price</ControlLabel>
                  <FormControl
                    value={this.state.month_amount}
                    onChange={e => this.handleAmountChange('month', e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col md={6} xs={6}>
                <FormGroup>
                  <ControlLabel>Yearly Price</ControlLabel>
                  <FormControl
                    value={this.state.year_amount}
                    onChange={e => this.handleAmountChange('year', e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </div>
        ) : null}
        {!this.state.updating ? (
          <div>
            <FormGroup>
              <ControlLabel>Plan Type</ControlLabel>
              <Select
                placeholder='Plan Type'
                options={this.plan_type_options}
                value={this.state.type}
                onChange={({ value }) => this.setState({ type: value })}
              />
            </FormGroup>
            <PlansPermissionsSelector
              handleChange={this.handlePermissionsChange}
              current_entity={{ features: this.state.permissions }}
            />
            <PlansDiscountForm
              discounts={this.state.discounts}
              handleAddDiscount={this.handleAddDiscount}
              handleEditDiscount={this.handleEditDiscount}
              handleRemoveDiscount={idx => this.setState({ removing_discount_idx: idx })}
              handleSave={this.handleSave}
            />
          </div>
        ) : null}
        <Row>
          <Col md={3} xs={3} mdOffset={6} xsOffset={6}>
            <Button
              block
              onClick={this.props.handleCancel}
              >
              Cancel
            </Button>
          </Col>
          <Col md={3} xs={3}>
            <Button
              block
              onClick={this.handleSave}
              bsStyle='success'
              >
              {requesting_create_plan || requesting_update_plan ? <LoadingSpinner size={2} /> : 'Save'}
            </Button>
          </Col>
        </Row>
        {this.state.removing_discount_idx !== null ? (
          <ConfirmationPrompt
            key='removing_discount_idx'
            show_condition={this.state.removing_discount_idx !== null}
            handleCancelPrompt={() => this.setState({ removing_discount_idx: null })}
            handleConfirmPrompt={this.confirmRemoveDiscount}
            type='danger'
            title='Remove Discount?'
            body='Are you sure you want to remove this discount?'
            bsSize='small'
            confirm_button_text='Remove'
            cancel_button_text='Cancel'
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({ plans, features }) => ({ plans, features });

export default connect(mapStateToProps, { requestCreatePlan, push })(PlanForm);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/plans/plan-form.js